import React from "react";
import { Header } from "../0_layout/HeaderFooter";
import { Footer } from "../0_layout/Footer";
import { Box} from "@mui/material";
import Events from "../1_home2/Events";

export default function EventLayout() {
  return (
    <>
      {/* Root Container to Prevent Overflow */}
      <Box sx={{ overflowX: 'hidden' }}>
        <Header />

        
        {/* Main Layout with Padding for Header Space */}
        <Box sx={{pt:{xs:1, sm:15}}}>


          <Events/>

          
        </Box>
        <Footer></Footer>

      </Box>
    </>
  );
}
